import { createAsyncTypes } from 'utils/ActionCreator'

const constantsKey = 'Settings/MalwareDetection'

export const GET_MALWARE_DETECTIONS_ASYNC = createAsyncTypes('GET_MALWARE_DETECTIONS', constantsKey)
export const UPDATE_MALWARE_DETECTION_ASYNC = createAsyncTypes(
  'UPDATE_MALWARE_DETECTION',
  constantsKey
)
export const DELETE_MALWARE_DETECTION_ASYNC = createAsyncTypes(
  'DELETE_MALWARE_DETECTION',
  constantsKey
)

export const RESET_MALWARE_DETECTION_ERROR = `${constantsKey}/RESET_MALWARE_DETECTION_ERROR`
